import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Stack, Link } from '@mui/material';

import { settingsService } from '../services/api';

const LOGO_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8888/api').replace('/api', '') + '/public';

const STATIC_LINKS = [
	{ label: 'Trang chủ', to: '/' },
	// { label: 'Khách sạn', to: '/hotels' },
	{ label: 'Giới thiệu', to: '/about' },
	// { label: 'Liên hệ', to: '/contact' },
];

const Footer = () => {
	const [siteSettings, setSiteSettings] = useState(null);

	useEffect(() => {
		let mounted = true;
		settingsService.getSettings()
			.then((res) => { if (mounted) setSiteSettings(res?.data || null); })
			.catch(() => {});
		return () => { mounted = false; };
	}, []);

	const customMenu = (siteSettings?.menuItems || [])
		.filter((m) => m.isActive !== false)
		.sort((a, b) => (a.order || 0) - (b.order || 0))
		.map((m) => ({ label: m.label, to: m.path || '#' }));

	const menuLinks = [...STATIC_LINKS, ...customMenu];

	return (
		<Box component="footer" sx={{ bgcolor: '#0B0C10', color: '#E5E5E5', mt: 'auto', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
			<Container maxWidth="lg" sx={{ py: { xs: 4, md: 5 } }}>
				<Stack
					direction={{ xs: 'column', md: 'row' }}
					alignItems={{ xs: 'flex-start', md: 'center' }}
					justifyContent="space-between"
					spacing={{ xs: 3, md: 2 }}
				>
					{/* Logo */}
					<Stack direction="row" alignItems="center" spacing={1.5}>
						{siteSettings?.logo?.path ? (
							<Box
								component="img"
								src={`${LOGO_BASE}${siteSettings.logo.path}`}
								alt="logo"
								sx={{ height: 32, width: 'auto', objectFit: 'contain' }}
							/>
						) : null}
						<Typography sx={{
							fontFamily: "'Playfair Display', Georgia, serif",
							fontSize: 20, letterSpacing: '0.18em', fontWeight: 600,
							color: '#fff', textTransform: 'uppercase',
						}}>
							Travel<Box component="span" sx={{ color: '#D4AF37', fontWeight: 400 }}>EXPEDIA</Box>
						</Typography>
					</Stack>

					{/* Menu */}
					<Stack
						direction="row"
						spacing={{ xs: 2, md: 3 }}
						useFlexGap
						flexWrap="wrap"
						alignItems="center"
					>
						{menuLinks.map((l) => (
							<Link
								key={l.to + l.label}
								component={RouterLink}
								to={l.to}
								underline="none"
								sx={{
									color: 'rgba(255,255,255,0.55)',
									fontSize: 13,
									fontFamily: "'Inter', sans-serif",
									letterSpacing: '0.08em',
									textTransform: 'uppercase',
									fontWeight: 500,
									transition: 'color .2s',
									'&:hover': { color: '#D4AF37' },
								}}
							>
								{l.label}
							</Link>
						))}
					</Stack>
				</Stack>

				<Typography
					sx={{ display: 'block', mt: 3, fontSize: 11, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.25)', textAlign: { xs: 'left', md: 'center' } }}
				>
					© {new Date().getFullYear()} TravelExpedia. All rights reserved.
				</Typography>
			</Container>
		</Box>
	);
};

export default Footer;
